import InductionConditionCRU from './InductionConditionCRU';
import InductionConditionList from './InductionConditionList';
export {InductionConditionCRU,InductionConditionList};

 export const InductionConObj={
asset_conditions_for_contract_id:null,
terms:null,
remarks:null,

}